import { Action } from '@ngrx/store';
import { Customer } from '../../core/models/customer';
import { RequestWrap } from '../../core/models/request-wrap';

export const GET = '[Customers] Get Customers'
export const GET_SUCCESS = '[Customers] Get Customers Success'
export const GET_FAILED = '[Customers] Get Customers Failed'

export const EXPAND = '[Customers] Expand Customers'
export const EXPAND_SUCCESS = '[Customers] Expand Customers Success'
export const EXPAND_FAILED = '[Customers] Expand Customers Failed'

export const SEARCH = '[Customers] Search Start'
export const SEARCH_SUCCESS = '[Customers] Search Success'
export const SEARCH_FAILED = '[Customers] Search Failed'


export class Get implements Action {
  readonly type = GET
}

export class GetSuccess implements Action {
  readonly type = GET_SUCCESS
  constructor(public payload: RequestWrap<Customer[]>) {}
}

export class GetFailed implements Action {
  readonly type = GET_FAILED
  constructor(public payload: any) {}
}

export class Expand implements Action {
  readonly type = EXPAND
}

export class ExpandSuccess implements Action {
  readonly type = EXPAND_SUCCESS
  constructor(public payload: RequestWrap<Customer[]>) {}
}

export class ExpandFailed implements Action {
  readonly type = EXPAND_FAILED
  constructor(public payload: any) {}
}

export class Search implements Action {
  readonly type = SEARCH
  constructor(public payload: string) {}
}

export class SearchSuccess implements Action {
  readonly type = SEARCH_SUCCESS
  constructor(public payload: RequestWrap<Customer[]>) {}
}

export class SearchFailed implements Action {
  readonly type = SEARCH_FAILED
  constructor(public payload: any) {}
}

export type Actions =
  Get
  | GetSuccess
  | GetFailed
  | Expand
  | ExpandSuccess
  | ExpandFailed
  | Search
  | SearchSuccess
  | SearchFailed
